/**
 * Famous lines from the James Bond films — martini easter egg (desktop).
 */
export const JAMES_BOND_QUOTES = [
  'Shaken, not stirred.',
  'The name\'s Bond. James Bond.',
  'Bond. James Bond.',
  'A martini. Shaken, not stirred.',
  'Vodka martini—shaken, not stirred.',
  'Do I look like I give a damn?',
  'I think he got the point.',
  'Diamonds are forever.',
  'You only live twice.',
  'From Russia with Love.',
  'Live and Let Die.',
  'We have all the time in the world.',
  'Everybody needs a hobby.',
  'History isn\'t kind to men who play God.',
  'Now pay attention, 007.',
  'I must be dreaming.',
  'Looks like we\'re out of time.',
  'Half monk, half hit man.',
  'Cocky little devil, aren\'t you?',
  'There\'s a useful four-letter word, and you\'re full of it.',
  'What makes you think this is my first time?',
  'I am invincible!',
  'Take a deep breath—it\'s just the end.',
  'Why is it that people who can\'t take advice always insist on giving it?',
  'The proper function of man is to live, not to exist.',
  'Dry martini—three measures of Gordon\'s, one of vodka, half a measure of Kina Lillet…',
  'Champagne… Dom Pérignon \'52.',
  'I have a slight inferiority complex.',
  'The coldest weapon of all.',
  'The things I do for England.',
  'I never miss.',
  'Explosions are just the punctuation.',
  'We\'re not playing bridge, darling.',
  'They say the world is not enough—they\'re right; I need a refill.',
  'I should have known you\'d enjoy something so twisted.',
  'You didn\'t think I\'d miss this performance, did you?',
  'I always hated this place.',
  'Regret is unprofessional.',
  'Arrogance and self-awareness seldom go hand in hand.',
  'I\'ve got a little itch—down there.',
  'Well, I like to do some things the old-fashioned way.',
  'I\'m sorry—that last hand nearly killed me.',
  'I love a spirited game.',
  'In poker you never play your hand—you play the man across from you.',
  'You shouldn\'t have interrupted me.',
  'I hope our little game isn\'t causing you to perspire.',
  'You changed your shirt, Mr Bond.',
];
